export default {
  KSCGY: {
    title: 'UPSC 2021- UPSC Civil Service Exam and Preparation on Unacademy.',
    description:
      "Crack UPSC CSE General Studies with guidance of Top Educators on Unacademy. Ace your UPSC prelims with  Unlimited Access to Live Classes from India's Top UPSC Educators."
  },
  TMUVD: {
    title: 'JEE 2021 - IIT JEE Mains & Advanced Online Classes on Unacademy',
    description:
      'Crack JEE with guidance of Top Educators on Unacademy. Get access to in-depth test analysis, Live and Recorded Classes, Mock Tests and more for JEE Advance preparation.'
  },
  PLWCX: {
    title:
      'CBSE Class 12 Exam Preparation 2021- Class 12 Online Classes on Unacademy',
    description:
      'Want to ace CBSE Class 12? At Unacademy, you get access to Interactive Live Classes by India’s Top Educators. Let’s crack your CBSE 12 with Unacademy.'
  },
  GWDPZ: {
    title:
      'CBSE Class 11 Exam Preparation 2021- Class 11 Online Classes on Unacademy',
    description:
      'Join the Interactive Live Classes to crack Class 11 CBSE exam. Take your preparation to the next level with Live Classes for class 11 CBSE provided on Unacademy.'
  },
  GSZGO: {
    title:
      'CBSE Class 10 Exam Preparation 2021- Class 10 Online Classes on Unacademy',
    description:
      'Ace your CBSE Class 10 exam by learning from Top Educators. Get Unlimited Access to CBSE class 10 Live Classes on Unacademy.'
  },
  SUVLV: {
    title:
      'CBSE Class 9 Exam Preparation 2021- Class 9 Online Classes on Unacademy',
    description:
      'Get Unlimited Access to Interactive Live Classes on India’s largest online learning platform - Unacademy. Start connecting with Top Educators today.'
  },
  TICPI: {
    title:
      'CBSE Class 8 Exam Preparation 2021- Class 8 Online Classes on Unacademy',
    description:
      'Get access to CBSE Class 8 Live Classes from Top Educators on Unacademy. Get the best prep material for CBSE Class 8 course. Click here for details.'
  },
  RJDNO: {
    title:
      'CBSE Class 7 Exams Preparation 2021- Class 7 Online Classes on Unacademy',
    description:
      "Join Unacademy and ace CBSE Class 7 exams with India's Top Educators. Enroll and get Unlimited Access to study material for CBSE Class 7. Click here for details."
  },
  KVBFU: {
    title:
      'CBSE Class 6 Exams Preparation 2021- Class 6 Online Classes on Unacademy',
    description:
      'Looking for Live Classes for CBSE Class 6? Get assistance from Top Educators. Ace CBSE Class 6 with Unacademy. Know more about CBSE Live and Interactive Classes.'
  },
  VLEMN: {
    title: 'SSC 2021 - SSC Exams Preparation and Online Classes on Unacademy',
    description:
      'Clear SSC Exam with Unacademy. Learn from India’s Top Educators and get Unlimited Access to our live learning sessions. Let’s Crack It with Unacademy.'
  },
  YOTUH: {
    title: 'NEET 2021 - NEET Preparation and NEET Online Classes on Unacademy',
    description:
      'Preparing for NEET? Choose Unacademy to get guidance from Top Educators for NEET. Enroll and get unlimited access to recorded and Live Classes for NEET exam.'
  }
};
